<template>
  <div class="flex">
    <div class="rounded-lg shadow-lg bg-white w-full">
			<router-link :to="`/campaign/${campaign.id}`">
        <img :src="campaign.thumbnail" class="rounded-t-lg w-full h-64 object-cover"  :alt="`thumbnail ${campaign.title}`"/>
      </router-link>
      <div class="p-6">
        <vs-row class="justify-between">
          <vs-col vs-w="9">
            <h5 id="title-campaign">{{campaign.title}}</h5>
            <p>{{moment(campaign.durationEndDate).format('DD MMMM YYYY')}}</p>
          </vs-col>
          <vs-col vs-w="3" class="flex items-end">
            <vs-button :to="`/campaign/edit/${campaign.id}`" class="ml-auto" color="success" type="filled" size="small" icon="edit"></vs-button>
            <vs-button @click="destroy(campaign.id)" class="ml-2" color="danger" type="filled" size="small" icon="delete"></vs-button>
          </vs-col>
        </vs-row>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import {
		getUrlOfFile
	} from '@/utils/helpers.js';
export default {
  props: {
    campaign: Object
  },
  data() {
    return {
      moment,
      getUrlOfFile
    }
  },
  methods: {
    destroy(id){
      this.$emit('destroy', id)
    }
  }
}
</script>

<style>
#title-campaign {
   overflow: hidden;
   text-overflow: ellipsis;
   display: -webkit-box;
   -webkit-line-clamp: 2; /* number of lines to show */
           line-clamp: 2;
   -webkit-box-orient: vertical;
}
</style>